/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Subscription_ActivatedInputs */

const en_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription activated! Your account has been upgraded.`)
};

const de_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement aktiviert! Dein Konto wurde aktualisiert.`)
};

const fr_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement activé ! Ton compte a été mis à niveau.`)
};

const es_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Suscripción activada! Su cuenta ha sido mejorada.`)
};

const it_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonamento attivato! Il tuo account è stato aggiornato.`)
};

const nl_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement geactiveerd! Je account is geüpgraded.`)
};

const pl_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subskrypcja aktywowana! Twoje konto zostało uaktualnione.`)
};

const fi_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilaus aktivoitu! Tiliäsi on päivitetty.`)
};

const da_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement aktiveret! Din konto er blevet opgraderet.`)
};

const sv_settings_subscription_activated = /** @type {(inputs: Settings_Subscription_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenumeration aktiverad! Ditt konto har uppgraderats.`)
};

/**
* | output |
* | --- |
* | "Subscription activated! Your account has been upgraded." |
*
* @param {Settings_Subscription_ActivatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_subscription_activated = /** @type {((inputs?: Settings_Subscription_ActivatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Subscription_ActivatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_subscription_activated(inputs)
	if (locale === "fr") return fr_settings_subscription_activated(inputs)
	if (locale === "es") return es_settings_subscription_activated(inputs)
	if (locale === "it") return it_settings_subscription_activated(inputs)
	if (locale === "nl") return nl_settings_subscription_activated(inputs)
	if (locale === "pl") return pl_settings_subscription_activated(inputs)
	if (locale === "fi") return fi_settings_subscription_activated(inputs)
	if (locale === "da") return da_settings_subscription_activated(inputs)
	if (locale === "sv") return sv_settings_subscription_activated(inputs)
	return en_settings_subscription_activated(inputs)
});